import fp from 'lodash/fp';
import { FaCalculator, FaUserCheck } from 'react-icons/fa';

export const getDefaultProgressLabel = fp.flow(
  fp.get('trainingPlans'),
  fp.map('industry.defaultProgressLabel'),
  fp.getOr('CPD Progress')('[0]')
)

export const getProgressGoalIcon = (name) => {
  switch (name) {
    case 'TPB CPE': return FaCalculator
    case 'RM CPD': return FaUserCheck
    default: return null
  }
}


// WEBPACK FOOTER //
// ./src/services/industry.js